"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphqlError = exports.Unauthorized = exports.BadRequest = exports.HasuraEventActionNameValidationError = exports.HasuraEventActionInputValidationError = exports.HasuraEventHeaderValidationError = exports.HasuraEventBodyValidationError = exports.HasuraEventJWTSecretValidationError = exports.HasuraEventUserAgentValidationError = exports.HasuraEventHttpMethodValidationError = exports.AwsLambdaEventJSONBodyValidationError = exports.InvalidDateTimeFormat = exports.UnknownVariableType = exports.InvalidVariablePattern = exports.InvalidVariableMaxLength = exports.InvalidVariableMinLength = exports.InvalidVariableType = exports.ServerInvalidEnvVariableError = exports.ServerMissingEnvVariableError = exports.InvalidOffset = exports.InvalidRangeError = exports.ServerStartTimeError = exports.VariableValidationBase = exports.UnknownError = exports.isErrorJSONFormat = void 0;
function isErrorJSONFormat(error) {
    return "statusCode" in error;
}
exports.isErrorJSONFormat = isErrorJSONFormat;
class UnknownError extends Error {
    constructor(error) {
        super("Unknown Error");
        this.error = error;
    }
    toJSON() {
        return {
            name: UnknownError.errorName,
            message: "Something went wrong on the server",
            detail: {
                stack: this.error.stack || this.stack,
                message: this.error.message || "Error is not properly handled",
            },
            statusCode: 500,
        };
    }
}
exports.UnknownError = UnknownError;
UnknownError.errorName = "UnknownError";
class AwsLambdaEventValidationError extends Error {
    toJSON() {
        return {
            name: AwsLambdaEventValidationError.errorName,
            message: "Invalid event",
            detail: {
                stack: this.stack,
                message: this.message,
            },
        };
    }
}
AwsLambdaEventValidationError.errorName = "AwsLambdaEventValidationError";
class VariableValidationBase extends Error {
    constructor(variableName, message) {
        super(message);
        this.statusCode = 400;
        this.variableName = variableName;
    }
    toJSON() {
        return {
            statusCode: this.statusCode,
            name: "VariableValidation",
            message: `Invalid variable ${this.variableName}`,
            detail: {
                variableName: this.variableName,
                stack: this.stack,
                message: this.message,
            },
        };
    }
}
exports.VariableValidationBase = VariableValidationBase;
class ServerStartTimeError extends Error {
}
exports.ServerStartTimeError = ServerStartTimeError;
class InvalidRangeError extends Error {
    constructor() {
        super(...arguments);
        this.statusCode = 400;
    }
    toJSON() {
        return {
            name: InvalidRangeError.errorName,
            statusCode: this.statusCode,
            detail: {
                stack: this.stack,
                message: `${InvalidRangeError.errorName}: ${this.message}`,
            },
            message: this.message,
        };
    }
}
exports.InvalidRangeError = InvalidRangeError;
InvalidRangeError.errorName = "InvalidRangeError";
class InvalidOffset extends Error {
    constructor(offset) {
        super(`No timezone found against this offset ${offset}`);
        this.statusCode = 400;
    }
    toJSON() {
        return {
            name: InvalidOffset.errorName,
            statusCode: this.statusCode,
            detail: {
                stack: this.stack,
                message: `${InvalidOffset.errorName}: ${this.message}`,
            },
            message: this.message,
        };
    }
}
exports.InvalidOffset = InvalidOffset;
InvalidOffset.errorName = "InvalidOffset";
class ServerMissingEnvVariableError extends ServerStartTimeError {
    constructor(variableName) {
        super(`MissingEnvVariable: Environment variable: ${variableName} is required.`);
    }
}
exports.ServerMissingEnvVariableError = ServerMissingEnvVariableError;
class ServerInvalidEnvVariableError extends ServerStartTimeError {
    constructor(variableName, error) {
        super(`InvalidEnvVariableValue for ${variableName}: ${error.message}`);
    }
}
exports.ServerInvalidEnvVariableError = ServerInvalidEnvVariableError;
class InvalidVariableType extends VariableValidationBase {
    constructor(variableName, expected, received) {
        super(variableName, `Invalid Type: expected "${variableName}" to be ${expected} but received ${received}`);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: InvalidVariableType.errorName,
            message: `${this.variableName} type is not valid.`,
        };
    }
}
exports.InvalidVariableType = InvalidVariableType;
InvalidVariableType.errorName = "InvalidVariableType";
class InvalidVariableMinLength extends VariableValidationBase {
    constructor(variableName, minLength) {
        super(variableName, `${InvalidVariableMinLength.errorName}: length of "${variableName}" should be greater than or equal to ${minLength}`);
        this.minLength = minLength;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: InvalidVariableMinLength.name,
            message: `Minimum length should be ${this.minLength}.`,
        };
    }
}
exports.InvalidVariableMinLength = InvalidVariableMinLength;
InvalidVariableMinLength.errorName = "InvalidVariableMinLength";
class InvalidVariableMaxLength extends VariableValidationBase {
    constructor(variableName, maxLength) {
        super(variableName, `${InvalidVariableMaxLength.errorName}: length of "${variableName}" should be less than or equal to ${maxLength}`);
        this.maxLength = maxLength;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: InvalidVariableMinLength.name,
            message: `Maximum length should be ${this.maxLength}.`,
        };
    }
}
exports.InvalidVariableMaxLength = InvalidVariableMaxLength;
InvalidVariableMaxLength.errorName = "InvalidVariableMaxLength";
class InvalidVariablePattern extends VariableValidationBase {
    constructor(variableName, patternPlaceholder, name) {
        super(variableName, `Value of "${variableName}" does not match the pattern. Requires valid ${name} e.g: ${patternPlaceholder}`);
        this.placeHolder = patternPlaceholder;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: InvalidVariablePattern.name,
            message: `${this.variableName} is not a valid format (expected ${this.placeHolder}).`,
        };
    }
}
exports.InvalidVariablePattern = InvalidVariablePattern;
InvalidVariablePattern.errorName = "InvalidVariablePattern";
class UnknownVariableType extends Error {
    constructor() {
        super("Unknown Value Type provided");
        this.statusCode = 500;
    }
    toJSON() {
        return {
            detail: {
                stack: this.stack,
            },
            statusCode: this.statusCode,
            name: "InternalServerError",
            message: `Variable type is not known to the server.`,
        };
    }
}
exports.UnknownVariableType = UnknownVariableType;
class InvalidDateTimeFormat extends VariableValidationBase {
    constructor(format, variableName) {
        super(variableName, `Invalid format for ${variableName}: expected ${format}`);
        this.format = format;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: InvalidDateTimeFormat.name,
            message: `Invalid format. (expected ${this.format})`,
        };
    }
}
exports.InvalidDateTimeFormat = InvalidDateTimeFormat;
InvalidDateTimeFormat.errorName = "InvalidDateTimeFormat";
class AwsLambdaEventJSONBodyValidationError extends AwsLambdaEventValidationError {
    constructor(body) {
        super(`AWS event.body is not valid JSON: ${body}`);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: AwsLambdaEventJSONBodyValidationError.errorName,
            statusCode: 400,
            message: "Request body is not a valid JSON",
        };
    }
}
exports.AwsLambdaEventJSONBodyValidationError = AwsLambdaEventJSONBodyValidationError;
AwsLambdaEventJSONBodyValidationError.errorName = "AwsLambdaEventJSONBodyValidationError";
class HasuraEventValidationError extends AwsLambdaEventValidationError {
    constructor() {
        super(...arguments);
        this.statusCode = 400;
    }
}
HasuraEventValidationError.errorName = "HasuraEventValidationError";
class HasuraEventHttpMethodValidationError extends HasuraEventValidationError {
    constructor(httpMethod) {
        super(`Invalid Hasura HTTP method: ${httpMethod}`);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: HasuraEventHttpMethodValidationError.errorName,
            statusCode: this.statusCode,
            message: "Request method should be POST",
        };
    }
}
exports.HasuraEventHttpMethodValidationError = HasuraEventHttpMethodValidationError;
HasuraEventHttpMethodValidationError.errorName = "HasuraEventHttpMethodValidationError";
class HasuraEventUserAgentValidationError extends HasuraEventValidationError {
    constructor(userAgent) {
        super(`Invalid Hasura user-agent: ${userAgent}`);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: HasuraEventUserAgentValidationError.errorName,
            statusCode: this.statusCode,
            message: "user-agent header is invalid",
        };
    }
}
exports.HasuraEventUserAgentValidationError = HasuraEventUserAgentValidationError;
HasuraEventUserAgentValidationError.errorName = "HasuraEventUserAgentValidationError";
class HasuraEventJWTSecretValidationError extends HasuraEventValidationError {
    constructor() {
        super("Missing Header: jwt_secret_key");
        this.statusCode = 500;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: HasuraEventJWTSecretValidationError.errorName,
            statusCode: this.statusCode,
            message: this.message,
        };
    }
}
exports.HasuraEventJWTSecretValidationError = HasuraEventJWTSecretValidationError;
HasuraEventJWTSecretValidationError.errorName = "HasuraEventJWTSecretValidationError";
// istanbul ignore next
class HasuraEventBodyValidationError extends HasuraEventValidationError {
    constructor(body) {
        super(`Hasura event body is invalid: ${JSON.stringify(body)}`);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: HasuraEventJWTSecretValidationError.errorName,
            statusCode: this.statusCode,
            message: "Request body is not valid",
        };
    }
}
exports.HasuraEventBodyValidationError = HasuraEventBodyValidationError;
HasuraEventBodyValidationError.errorName = "HasuraEventBodyValidationError";
class HasuraEventHeaderValidationError extends HasuraEventValidationError {
    constructor(error) {
        super(`${error.message}. (in headers)`);
        this.statusCode = 400;
        this.error = error;
    }
    toJSON() {
        return this.error.toJSON();
    }
}
exports.HasuraEventHeaderValidationError = HasuraEventHeaderValidationError;
class HasuraEventActionInputValidationError extends HasuraEventValidationError {
    constructor(error) {
        super(`${error.message}. (in body)`);
        this.error = error;
    }
    toJSON() {
        return this.error.toJSON();
    }
}
exports.HasuraEventActionInputValidationError = HasuraEventActionInputValidationError;
class HasuraEventActionNameValidationError extends HasuraEventValidationError {
    constructor(expected, received) {
        super(`Incorrect Hasura action handler name received:  expected: ${expected} received: ${received}`);
        this.statusCode = 500;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            message: "Hasura Action name is invalid",
            statusCode: this.statusCode,
            name: HasuraEventActionNameValidationError.errorName,
        };
    }
}
exports.HasuraEventActionNameValidationError = HasuraEventActionNameValidationError;
HasuraEventActionNameValidationError.errorName = "HasuraEventActionNameValidationError";
class BadRequest extends AwsLambdaEventValidationError {
    constructor() {
        super(...arguments);
        this.statusCode = 400;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: BadRequest.errorName,
            message: this.message,
            statusCode: this.statusCode,
        };
    }
}
exports.BadRequest = BadRequest;
BadRequest.errorName = "BadRequest";
class Unauthorized extends Error {
    constructor() {
        super(...arguments);
        this.statusCode = 401;
    }
    toJSON() {
        return {
            detail: {
                stack: this.stack,
            },
            name: Unauthorized.errorName,
            statusCode: 500,
            message: "Something went wrong on the server.",
        };
    }
}
exports.Unauthorized = Unauthorized;
Unauthorized.errorName = "Unauthorized";
class GraphqlError extends Error {
    constructor(graphQLResponse) {
        super("Something went wrong on the server.");
        this.statusCode = 400;
        this.graphQLResponse = graphQLResponse;
    }
    toJSON() {
        return {
            detail: {
                stack: this.stack,
                graphQLResponse: this.graphQLResponse,
            },
            name: GraphqlError.errorName,
            statusCode: 500,
            message: "Something went wrong on the server.",
        };
    }
}
exports.GraphqlError = GraphqlError;
GraphqlError.errorName = "GraphqlError";
//# sourceMappingURL=errors.js.map